<template>
  <div class="addevent container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Edit Event</h4>
              </div>
            </div>
          </div>
          <div class="createeventCard">
            <EventInfo
              client_name="MID"
              field_name="event"
              action="update"
              :locations="locations"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventInfo from "@/components/events/EventInfo.vue";

export default {
  name: "EditEvent",
  components: { EventInfo },
  data() {
    return {
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "New location", id: "on_site" },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/events/EditEvent.vue